import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-184" data-mp="20m4qnvskykwl">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-navy-100 bg-cream p-6 text-center sm:p-10" data-id="element-185" data-mp="24mydsmy77vof">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-navy-900" data-id="element-186" data-mp="29eyistt4lerv">
          <ShieldCheckIcon className="h-7 w-7 text-white" aria-hidden="true" data-id="element-187" data-mp="2ec86o50v9idl" />
        </span>
        <p className="mt-4 text-[11px] font-extrabold uppercase tracking-[0.16em] text-brick-600 sm:text-xs" data-id="element-188" data-mp="2jb1na6bg9phz">
          7-day guarantee
        </p>
        <h2 className="mt-2.5 text-balance font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-189" data-mp="2o9cvydq0dtym">
          Explore it. Use it. Decide for yourself.
        </h2>
        <p className="mt-4 text-[14.5px] font-medium leading-relaxed text-navy-600 sm:text-base" data-id="element-190" data-mp="tyzjm81hkt3r">
          You’ll have 7 days to access the system, review the clinical pathways, and determine
          whether Kidney Disease Route™ provides the practical clarity you’re looking for.
        </p>
        <p className="mt-3 text-[14.5px] font-medium leading-relaxed text-navy-600 sm:text-base" data-id="element-191" data-mp="3ntf30ak1cega">
          If you decide it isn’t right for you, simply contact us within the guarantee period and
          we’ll refund your purchase according to our refund policy. No complicated process. No
          long-term commitment. No risk.
        </p>

        <div className="mt-8" data-id="element-192" data-mp="afabvirl4ofy">
          <CTAButton label="Yes — I want to try Kidney Disease Route™" subline="Get instant access for $27 • Protected by our 7-day guarantee" data-id="element-193" data-mp="ah4vmtr4eaig" />
        </div>
      </div>
    </section>;
}